module.exports = __webpack_public_path__ + "img/service-bak2.42b44e10.png";